export default __webpack_public_path__ + "assets/header_logo_small.0050bc13.svg";